export type SortOrder =
    'ASC' |
    'DESC' |
    'ASC_NULLS_FIRST' |
    'DESC_NULLS_FIRST' |
    'ASC_NULLS_LAST' |
    'DESC_NULLS_LAST';

export const SortOrderDescription: Record<SortOrder, string> = {
    ASC: '오름차순',
    DESC: '내림차순',
    ASC_NULLS_FIRST: '오름차순(값이 없을 때 우선 표시)',
    DESC_NULLS_FIRST: '내림차순(값이 없을 때 우선 표시)',
    ASC_NULLS_LAST: '오름차순(값이 있을 때 우선 표시)',
    DESC_NULLS_LAST: '내림차순(값이 있을 때 우선 표시)'
}